import { Card, TextStyle, TextField } from "@shopify/polaris";
import React, { useEffect, useRef } from "react";
import { Col, Row } from "reactstrap";
import "../../css/video-tutorial.css";

const VideoTutorial = () => {
    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);
    const ref7 = useRef(null);
    const ref8 = useRef(null);

    const listRef = [ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8]

    const listVideo = [
        {
            label: "Add tracking numbers faster with Synctrack - 3 steps you should know",
            url: "nFUq_tjImpk",
        },
        {
            label: "Unlimited PayPal accounts on Synctrack - Way to increase the work efficiency",
            url: "tOPa3UTCC3s",
        },
        {
            label: "Multi-store integration - Instructions to use and 2 benefits you need to know",
            url: "U_m9Jh4N3wY",
        },
        {
            label: "Match courier name to Paypal - an easy way to track your order",
            url: "aSiDS_ncu2c",
        },
        {
            label: "Shopify order notes - An important benefit of Synctrack",
            url: "90A0Th9KQgs",
        },
        {
            label: "Fair Pricing on Synctrack - Providing an ideal package for you!",
            url: "YCM-DHHON2c",
        },
        {
            label: "Synctrack - Auto-sync tracking info to PayPal & Stripe",
            url: "2x6FjfGs8yw",
        },
        {
            label: "Dispute management - control your orders' status in 1 click",
            url: "etWA_jgqutQ",
        },
    ];

    const handleScroll = (index) => {
        listRef[index].current.scrollIntoView({
            alignToTop: true,
            block: "start",
            inline: "nearest",
            behavior: "smooth",
        })
    }

    return (
        <div className="st-video-tutorial">
            <Row>
                <Col>
                    {listVideo.map((item, index) => (
                        <div key={index} ref={listRef[index]}>
                            <div className="st-video-tutorial-title">
                                <TextStyle variation="strong">
                                    {index + 1}. {item.label}
                                </TextStyle>
                            </div>
                            <div className="st-video-tutorial-video">
                                <iframe
                                    src={
                                        "https://www.youtube.com/embed/" +
                                        item.url
                                    }
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                    title="Video Tutorial"
                                    width="100%"
                                    height="220"
                                />
                            </div>
                        </div>
                    ))}
                </Col>
                <Col>
                    <div className="st-video-tutorial-nav">
                        <div className="st-video-tutorial-heading">
                            <TextStyle variation="strong">
                                VIDEO TUTORIAL
                            </TextStyle>
                        </div>
                        <div>
                            {listVideo.map((item, index) => (
                                <div
                                    key={index}
                                    className="st-video-tutorial-nav-item"
                                    onClick={()=> handleScroll(index)}
                                >
                                    <Card sectioned>
                                        <p>{item.label}</p>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default VideoTutorial;
